import styled from "styled-components";

export const RouteOptimizationActions = styled.div`
  display: flex;
  gap: 15px;
  align-items: center;

  @media (max-width: 768px) {
    flex-wrap: wrap;
    width: 100%;
  }
`;

export const RouteOptimizationFilterContainer = styled.div`
  box-sizing: border-box;
  display: grid;
  grid-template-columns: auto;
  justify-content: start;
  grid-column-gap: 15px;
  width: 100%;

  @media (max-width: 1024px) {
    display: flex;
    flex-direction: column;
    gap: 10px;
    flex-wrap: wrap;
  }
`;

export const RoutesGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(400px, 1fr));
  gap: 20px;
  margin-top: 10px;

  @media (max-width: 768px) {
    grid-template-columns: 1fr;
  }
`;

export const RouteCard = styled.div`
  background-color: ${({ theme }) => theme.colors.main.white};
  border: 1px solid ${({ theme }) => theme.colors.border.secondaryLight};
  border-radius: ${({ theme }) => theme.borderRadii.card};
  padding: 20px;
  display: flex;
  flex-direction: column;
  gap: 15px;
  transition: box-shadow 0.3s ease;
  overflow: hidden;
  min-width: 0;

  &:hover {
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
  }
`;

export const RouteCardHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  gap: 10px;
`;

export const RouteEmployeeName = styled.h3`
  font-size: ${({ theme }) => theme.font.cardTitle.size};
  font-weight: ${({ theme }) => theme.font.cardTitle.weight};
  color: ${({ theme }) => theme.colors.main.textMain};
  margin: 0;
  flex: 1;
`;

export const RouteBadge = styled.span`
  font-size: 11px;
  font-weight: ${({ theme }) => theme.fontWeights.semibold};
  padding: 4px 10px;
  border-radius: ${({ theme }) => theme.borderRadii.button};
  background-color: ${({ mode, theme }) =>
    mode === "master" ? theme.colors.main.blue : theme.colors.main.primary};
  color: ${({ theme }) => theme.colors.main.white};
  text-transform: uppercase;
`;

export const LockBadge = styled.span`
  font-size: 11px;
  font-weight: ${({ theme }) => theme.fontWeights.semibold};
  padding: 4px 10px;
  border-radius: ${({ theme }) => theme.borderRadii.button};
  background-color: ${({ theme }) => theme.colors.main.warning};
  color: ${({ theme }) => theme.colors.main.white};
  display: flex;
  align-items: center;
  gap: 5px;
`;

export const RouteStats = styled.div`
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 10px;
  padding: 15px 0;
  border-top: 1px solid ${({ theme }) => theme.colors.border.secondaryLight};
  border-bottom: 1px solid ${({ theme }) => theme.colors.border.secondaryLight};
`;

export const RouteStat = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
`;

export const RouteStatLabel = styled.span`
  font-size: 12px;
  color: ${({ theme }) => theme.colors.main.labelText};
  font-weight: ${({ theme }) => theme.fontWeights.regular};
`;

export const RouteStatValue = styled.span`
  font-size: 16px;
  color: ${({ theme }) => theme.colors.main.textMain};
  font-weight: ${({ theme }) => theme.fontWeights.semibold};
`;

export const JobsList = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  max-height: 250px;
  overflow-y: auto;
  padding-right: 5px;

  ::-webkit-scrollbar {
    width: ${({ theme }) => theme.dropdown.scrollbar.width};
  }
  ::-webkit-scrollbar-track {
    background: ${({ theme }) => theme.dropdown.scrollbar.trackBgColor};
    border-radius: ${({ theme }) => theme.dropdown.scrollbar.thumbBorderRadius};
  }
  ::-webkit-scrollbar-thumb {
    background: ${({ theme }) => theme.dropdown.scrollbar.thumbBgColor};
    border-radius: ${({ theme }) => theme.dropdown.scrollbar.thumbBorderRadius};
  }
  ::-webkit-scrollbar-thumb:hover {
    background: ${({ theme }) => theme.dropdown.scrollbar.thumbHoverBgColor};
  }
`;

export const JobItem = styled.div`
  display: grid;
  grid-template-columns: 30px 1fr auto;
  gap: 10px;
  align-items: center;
  padding: 8px;
  background-color: ${({ theme }) => theme.colors.main.secondary};
  border-radius: ${({ theme }) => theme.borderRadii.button};
`;

export const JobSequence = styled.div`
  width: 24px;
  height: 24px;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: ${({ theme }) => theme.colors.main.primary};
  color: ${({ theme }) => theme.colors.main.white};
  border-radius: ${({ theme }) => theme.borderRadii.circle};
  font-size: 12px;
  font-weight: ${({ theme }) => theme.fontWeights.semibold};
`;

export const JobInfo = styled.div`
  display: flex;
  flex-direction: column;
  gap: 2px;
  min-width: 0;
`;

export const JobName = styled.span`
  font-size: 14px;
  font-weight: ${({ theme }) => theme.fontWeights.semibold};
  color: ${({ theme }) => theme.colors.main.textMain};
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;

export const JobAddress = styled.span`
  font-size: 12px;
  color: ${({ theme }) => theme.colors.main.labelText};
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;

export const JobStatus = styled.span`
  font-size: 10px;
  font-weight: ${({ theme }) => theme.fontWeights.semibold};
  padding: 3px 8px;
  border-radius: ${({ theme }) => theme.borderRadii.button};
  background-color: ${({ status, theme }) => {
    switch (status) {
      case "completed":
        return theme.colors.main.successLight;
      case "in_progress":
        return theme.colors.main.blueLight;
      case "pending":
        return theme.colors.main.warningLight;
      default:
        return theme.colors.main.secondary;
    }
  }};
  color: ${({ status, theme }) => {
    switch (status) {
      case "completed":
        return theme.colors.main.successText;
      case "in_progress":
        return theme.colors.main.blue;
      case "pending":
        return theme.colors.main.warning;
      default:
        return theme.colors.main.textSecondary;
    }
  }};
`;

export const RouteActions = styled.div`
  display: flex;
  gap: 10px;
  margin-top: 5px;
  flex-wrap: wrap;
  width: 100%;
  min-width: 0;

  & > * {
    min-width: 0;
    flex: 1 1 auto;

    @media (max-width: 480px) {
      flex: 1 1 calc(50% - 5px);
      min-width: calc(50% - 5px);
    }
  }
`;

export const ProgressOverlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
`;

export const ProgressCard = styled.div`
  background-color: ${({ theme }) => theme.colors.main.white};
  border-radius: ${({ theme }) => theme.borderRadii.card};
  padding: 40px;
  max-width: 400px;
  width: 90%;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 20px;
  box-shadow: 0 10px 40px rgba(0, 0, 0, 0.3);
`;

export const ProgressTitle = styled.h3`
  font-size: 18px;
  font-weight: ${({ theme }) => theme.fontWeights.semibold};
  color: ${({ theme }) => theme.colors.main.textMain};
  margin: 0;
`;

export const ProgressStatus = styled.p`
  font-size: 14px;
  color: ${({ theme }) => theme.colors.main.textSecondary};
  text-align: center;
  margin: 0;
`;

export const ProgressBarContainer = styled.div`
  width: 100%;
  height: 8px;
  background-color: ${({ theme }) => theme.colors.main.secondary};
  border-radius: 4px;
  overflow: hidden;
`;

export const ProgressBarFill = styled.div`
  height: 100%;
  background-color: ${({ theme }) => theme.colors.main.primary};
  transition: width 0.3s ease;
  width: ${({ progress }) => progress}%;
`;

export const EmptyState = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 60px 20px;
  text-align: center;
`;

export const EmptyStateIcon = styled.div`
  font-size: 64px;
  margin-bottom: 20px;
  opacity: 0.3;
`;

export const EmptyStateTitle = styled.h3`
  font-size: 20px;
  font-weight: ${({ theme }) => theme.fontWeights.semibold};
  color: ${({ theme }) => theme.colors.main.textMain};
  margin: 0 0 10px 0;
`;

export const EmptyStateText = styled.p`
  font-size: 14px;
  color: ${({ theme }) => theme.colors.main.textSecondary};
  margin: 0 0 30px 0;
`;

export const CompareModal = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
  padding: 20px;
`;

export const CompareModalContent = styled.div`
  background-color: ${({ theme }) => theme.colors.main.white};
  border-radius: ${({ theme }) => theme.borderRadii.card};
  padding: 30px;
  max-width: 900px;
  width: 100%;
  max-height: 90vh;
  overflow-y: auto;
  position: relative;
`;

export const CompareModalHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 30px;
`;

export const CompareModalTitle = styled.h2`
  font-size: 24px;
  font-weight: ${({ theme }) => theme.fontWeights.semibold};
  color: ${({ theme }) => theme.colors.main.textMain};
  margin: 0;
`;

export const StrategiesGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
  gap: 20px;

  @media (max-width: 768px) {
    grid-template-columns: 1fr;
  }
`;

export const StrategyCard = styled.div`
  border: 2px solid
    ${({ isActive, theme }) =>
      isActive
        ? theme.colors.main.primary
        : theme.colors.border.secondaryLight};
  border-radius: ${({ theme }) => theme.borderRadii.card};
  padding: 20px;
  display: flex;
  flex-direction: column;
  gap: 15px;
  background-color: ${({ isActive, theme }) =>
    isActive ? theme.colors.main.primaryLight : theme.colors.main.white};
`;

export const StrategyName = styled.h3`
  font-size: 16px;
  font-weight: ${({ theme }) => theme.fontWeights.semibold};
  color: ${({ theme }) => theme.colors.main.textMain};
  margin: 0;
`;

export const StrategyStats = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
`;

export const StrategyStat = styled.div`
  display: flex;
  justify-content: space-between;
  font-size: 13px;
`;

export const StatLabel = styled.span`
  color: ${({ theme }) => theme.colors.main.labelText};
`;

export const StatValue = styled.span`
  font-weight: ${({ theme }) => theme.fontWeights.semibold};
  color: ${({ theme }) => theme.colors.main.textMain};
`;

export const DatePickerWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;

  input {
    padding: 10px 15px;
    border: 1px solid ${({ theme }) => theme.colors.border.secondaryLight};
    border-radius: ${({ theme }) => theme.borderRadii.button};
    font-size: 14px;
    color: ${({ theme }) => theme.colors.main.textMain};
    font-weight: ${({ theme }) => theme.fontWeights.regular};

    &:focus {
      outline: none;
      border-color: ${({ theme }) => theme.colors.main.primary};
      box-shadow: ${({ theme }) => theme.input.focusShadow};
    }
  }
`;

export const MapContainer = styled.div`
  width: 100%;
  height: 500px;
  border-radius: ${({ theme }) => theme.borderRadii.card};
  overflow: hidden;
  border: 1px solid ${({ theme }) => theme.colors.border.secondaryLight};
  margin-top: 20px;
`;
